import React, { useEffect, useState } from "react";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { formattedCurrency } from "../../utils/helpers/calculateTime";

const ComposedProductStock = ({
  stockData,
  setStockData,
  totalQty,
  productionHistory,
  minMaxError,
  FetchTranslationList,
}) => {
  const t = (key) => FetchTranslationList?.[key] || "";
  const [paginationObj, setPaginationObj] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });

  const calculatePagination = (pageNumber) => {
    let records = productionHistory || [];
    let tempPaginationObj = {
      totalRecords: records.length,
      currentPage: pageNumber,
      startRecordIndex: Math.max(5 * pageNumber - 4, 1),
      endRecordIndex: Math.min(5 * pageNumber, records.length),
      totalPages: Math.ceil(records.length / 5),
      records: records?.slice((pageNumber - 1) * 5, pageNumber * 5),
    };
    setPaginationObj({ ...paginationObj, ...tempPaginationObj });
  };

  useEffect(() => {
    calculatePagination(1);
  }, [productionHistory]);

  const handleStockPartConsumptionChange = (e) => {
    const { name, checked } = e.target;
    setStockData((prevState) => ({
      ...prevState,
      isPickingPart: name === "isPickingPart" ? checked : false,
      isProductStockEntry: name === "isProductStockEntry" ? checked : false,
    }));
  };

  const handleValorizationChange = (e) => {
    const { name, checked } = e.target;
    setStockData((prevState) => ({
      ...prevState,
      isFifo: name === "isFifo" ? checked : false,
      isLifo: name === "isLifo" ? checked : false,
      isAverage: name === "isAverage" ? checked : false,
    }));
  };

  return (
    <div className="pt-4">
      <div className="row col-12 p-0 m-0">
        <div className="col-3  p-0 m-0">
          <div className="products-and-parts-toggle-area">
            <label>{t("Stock Management")}</label>
            <input
              type="checkbox"
              id="products-and-parts-switch2"
              className="checkbox"
              name="stockmanagement"
              checked={stockData?.enableStockManagement}
              value={stockData?.enableStockManagement}
              onChange={(e) =>
                setStockData((prevData) => ({
                  ...prevData,
                  enableStockManagement: e.target.checked,
                }))
              }
            />
            <label
              htmlFor="products-and-parts-switch2"
              className="toggle"
            ></label>
          </div>
          {stockData?.enableStockManagement && (
            <div className="d-flex gap-2 align-items-center">
              <div
                className="products-and-parts-asc-input-container"
                id="products-and-parts-ascInput"
              >
                <label
                  className={
                    minMaxError
                      ? "errorLabel products-and-parts-asc-label-top products-and-parts-item-id-title"
                      : "products-and-parts-asc-label-top products-and-parts-min-max-title"
                  }
                >
                  {/* Min */}
                  {t("Min")}
                </label>
                <input
                  type="number"
                  className={
                    minMaxError
                      ? "product-input-error products-and-parts-stock-inputs products-and-parts-min-max-input"
                      : "products-and-parts-stock-inputs products-and-parts-min-max-input"
                  }
                  placeholder="0"
                  value={stockData.minimum}
                  name="minimum"
                  onChange={(e) =>
                    setStockData((prevData) => ({
                      ...prevData,
                      minimum: e.target.value,
                    }))
                  }
                />
              </div>
              <div
                className="products-and-parts-asc-input-container"
                id="products-and-parts-ascInput"
              >
                <label
                  className={
                    minMaxError
                      ? "errorLabel products-and-parts-asc-label-top products-and-parts-item-id-title"
                      : "products-and-parts-asc-label-top products-and-parts-min-max-title"
                  }
                >
                  {/* Max */}
                  {t("Max")}
                </label>
                <input
                  type="number"
                  className={
                    minMaxError
                      ? "product-input-error products-and-parts-stock-inputs products-and-parts-min-max-input"
                      : "products-and-parts-stock-inputs products-and-parts-min-max-input"
                  }
                  placeholder="0"
                  value={stockData.maximum}
                  name="maximum"
                  onChange={(e) =>
                    setStockData((prevData) => ({
                      ...prevData,
                      maximum: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
          )}
        </div>
        <div className="col-9 row  p-0 m-0 justify-content-center">
          {stockData?.enableStockManagement && (
            <>
              <div className="position-relative col-6" id="ascInput">
                <label className="asc-label-top product-stock-title">
                  {/* Stock Part consumption{" "} */}
                  {t("Stock Part consumption")}
                </label>
                <div className="contactInput">
                  <div className="under-Texts">
                    <input
                      className="form-check-input pointer"
                      style={{ borderRadius: "50%" }}
                      type="checkbox"
                      id="ascInvoice"
                      value={stockData.isPickingPart}
                      name="isPickingPart"
                      checked={stockData.isPickingPart}
                      onChange={handleStockPartConsumptionChange}
                    />
                    <span className="form-check-label" for="flexCheckDefault">
                      {/* Picking Part */}
                      {t("Picking Part")}
                    </span>
                  </div>
                  <div className="under-Texts">
                    <input
                      className="form-check-input pointer"
                      style={{ borderRadius: "50%" }}
                      type="checkbox"
                      id="ascInvoice"
                      value={stockData.isProductStockEntry}
                      name="isProductStockEntry"
                      checked={stockData.isProductStockEntry}
                      onChange={handleStockPartConsumptionChange}
                    />
                    <span className="form-check-label" for="flexCheckDefault">
                      {/* Product Stock Entry */}
                      {t("Product stock entry")}
                    </span>
                  </div>
                </div>
              </div>
              <div className="position-relative col-6" id="ascInput">
                <label className="asc-label-top product-stock-title">
                  {/* Stock Valorization */}
                  {t("Stock Valorization")}
                </label>
                <div className="contactInput">
                  <div className="under-Texts">
                    <input
                      className="form-check-input pointer"
                      style={{ borderRadius: "50%" }}
                      type="checkbox"
                      id="ascInvoice"
                      value={stockData.isFifo}
                      name="isFifo"
                      checked={stockData.isFifo}
                      onChange={handleValorizationChange}
                    />
                    <span className="form-check-label" for="flexCheckDefault">
                      {/* FIFO (First in First out) */}
                      {t("FIFO")}{" "}
                      {t("(First in First out)")}
                    </span>
                  </div>
                  <div className="under-Texts">
                    <input
                      className="form-check-input pointer"
                      style={{ borderRadius: "50%" }}
                      type="checkbox"
                      id="ascInvoice"
                      value={stockData.isLifo}
                      name="isLifo"
                      checked={stockData.isLifo}
                      onChange={handleValorizationChange}
                    />
                    <span className="form-check-label" for="flexCheckDefault">
                      {/* LIFO (Last in First out) */}
                      {t("LIFO")}{" "}
                      {t("(Last in First out)")}
                    </span>
                  </div>
                  <div className="under-Texts">
                    <input
                      className="form-check-input pointer"
                      style={{ borderRadius: "50%" }}
                      type="checkbox"
                      id="ascInvoice"
                      value={stockData.isAverage}
                      name="isAverage"
                      checked={stockData.isAverage}
                      onChange={handleValorizationChange}
                    />
                    <span className="form-check-label" for="flexCheckDefault">
                      {/* Average */}
                      {t("Average")}
                    </span>
                  </div>
                </div>
              </div>
            </>
          )}

        </div>
        <div className="position-relative col-12 my-4 justify-content-start" id="ascInput">
          <label className="asc-label-top product-stock-title">
            {/* Stock Value(YTD) */}
            {t("Stock Value")}
            {t("(YTD)")}
          </label>
          <div className="contactInput">
            <div
              className="under-Texts "
              style={{
                justifyContent: !stockData?.enableStockManagement
                  ? "end"
                  : "space-around",
                paddingRight: !stockData?.enableStockManagement ? "15px" : "",
              }}
            >
              {stockData?.enableStockManagement && (
                <>
                  <span className="form-check-label " for="flexCheckDefault">
                    {/* Total Cost */}
                    {t("Total Cost")}
                  </span>
                  <span
                    className="form-check-label "
                    style={{ paddingRight: "30px" }}
                    for="flexCheckDefault"
                  >
                    {/* Unit Cost */}
                    {t("Unit Cost")}
                  </span>
                </>
              )}
              <span className="form-check-label" for="flexCheckDefault">
                {/* Quantity */}
                {t("Quantity")}
              </span>
            </div>
            <div
              className="under-Texts"
              style={{
                justifyContent: !stockData?.enableStockManagement
                  ? "end"
                  : "space-around",
                paddingRight: !stockData?.enableStockManagement ? "15px" : "",
              }}
            >
              {stockData?.enableStockManagement && (
                <>
                  <span className="form-check-label" for="flexCheckDefault">
                    {stockData.qty * totalQty
                      ? formattedCurrency(stockData.qty * totalQty)
                      : 0}
                  </span>
                  <span className="form-check-label" for="flexCheckDefault">
                    {totalQty ? formattedCurrency(totalQty) : 0}
                  </span>
                </>
              )}
              <input
                type="number"
                className="products-and-parts-tab-dimensions-input"
                value={stockData.qty}
                placeholder="0"
                onChange={(e) =>
                  setStockData((prevData) => ({
                    ...prevData,
                    qty: e.target.value,
                  }))
                }
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <div
          className="d-flex align-items-baseline justify-content-between px-3"
          style={{ borderBottom: "1px solid #8080806e" }}
        >
          <span className="product-stock-heading">
            {t("Purchasing History")}
          </span>
          <div className="products-and-parts-custom-pagination">
            <div className="range-text">
              {`${paginationObj.startRecordIndex} - ${paginationObj.endRecordIndex} of ${paginationObj.totalRecords}`}
            </div>
            <div className="products-and-parts-pagination-buttons">
              <div
                onClick={() =>
                  calculatePagination(paginationObj.currentPage - 1)
                }
                className={`products-and-parts-pagination-button ${
                  paginationObj.currentPage === 1 ? "disabled" : ""
                }`}
              >
                <BsChevronLeft />
              </div>
              <div className="pagination-current-page">
                {paginationObj.currentPage}
              </div>
              <div
                onClick={() =>
                  calculatePagination(paginationObj.currentPage + 1)
                }
                className={`products-and-parts-pagination-button ${
                  paginationObj.totalPages === 0 ||
                  paginationObj.totalPages === paginationObj.currentPage
                    ? "disabled"
                    : ""
                }`}
              >
                <BsChevronRight />
              </div>
            </div>
          </div>
        </div>
        <div
          className="d-flex align-items-center justify-content-between py-2 px-3"
          style={{ borderBottom: "1px solid #8080806e" }}
        >
          <div className="d-flex align-items-center gap-5">
            <span className="product-stock-heading">
              {t("Stock entry/out")}
            </span>
            <span className="product-stock-heading">
              {t("Date")}
            </span>
          </div>
          <span className="product-stock-heading">
            {t("Qty")}
          </span>
        </div>
        {productionHistory.length > 0 && (
          <>
            {paginationObj?.records?.map((item, index) => (
              <div
                style={{ borderBottom: "1px dotted #8080806e" }}
                key={index}
                className="d-flex align-items-center justify-content-between  py-2  px-3"
              >
                <div className="d-flex align-items-center gap-5">
                  <span
                    className="product-stock-des"
                    style={{ minWidth: "100px" }}
                  >
                    {item.orderCode}
                  </span>
                  <span className="product-stock-des">
                    {item.date.split("T")[0]}
                  </span>
                </div>
                <span className="product-stock-des">{item.qty}</span>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default ComposedProductStock;
